import { render, staticRenderFns } from "./Penilaianpaparan.vue?vue&type=template&id=1db8020b"
import script from "./Penilaianpaparan.vue?vue&type=script&lang=js"
export * from "./Penilaianpaparan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports